var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"police_detail"},[_c('common-detail',{attrs:{"title":_vm.detail.title,"imgList":_vm.detail.consultPictures}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }